import { Play } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { DASHBOARD_ALERT_GROUP_SOUNDS, type DashboardAlertGroup } from "./dashboardAlertCatalog";
import { DASHBOARD_ALERT_GROUP_TITLE } from "./dashboardAlertDisplay";
import { playDashboardAlertSound } from "./dashboardAlertSounds";

/** Plays one section's sound and, when it has one, the way it sounds when something went wrong. */
export function DashboardAlertGroupSoundButtons({
  group,
  className,
}: {
  group: DashboardAlertGroup;
  className?: string;
}) {
  const { t } = useTranslations("dashboardAlerts");
  const [ok, problem] = DASHBOARD_ALERT_GROUP_SOUNDS[group];
  const title = t(DASHBOARD_ALERT_GROUP_TITLE[group]);
  const pill = "h-6 rounded-full border border-border px-2 text-[11.5px]";
  return (
    <span className={cn("flex flex-wrap items-center gap-1.5", className)}>
      <ColocaButton
        size="xs"
        variant="ghost"
        icon={Play}
        aria-label={`${t("sound_listen")}: ${title}`}
        onClick={() => playDashboardAlertSound(ok, { force: true })}
        className={pill}
      >
        {t("sound_listen")}
      </ColocaButton>
      {problem && (
        <ColocaButton
          size="xs"
          variant="ghost"
          icon={Play}
          aria-label={`${t("sound_listen_problem")}: ${title}`}
          onClick={() => playDashboardAlertSound(problem, { force: true })}
          className={pill}
        >
          {t("sound_listen_problem")}
        </ColocaButton>
      )}
    </span>
  );
}
